import { CHANGELOG_ACTION_LABELS } from '../config/changelog-actions.const'

export const getChangelogActionLabel = (action: string): string =>
  CHANGELOG_ACTION_LABELS[action] ?? action
